import React from "react";
import "../../../css/web/StoreDesign.css";

/**
 * ════════════════════════════════════════════════════════════════════════════════
 *  상점사 포털 최상위 껍데기 — "여명 필드"
 * ════════════════════════════════════════════════════════════════════════════════
 *  모든 상점사 화면은 이 컴포넌트 안에서 렌더된다.
 *  .st-root 스코프를 열어주고, 시그니처인 여명 필드(3겹 오로라)와 그레인을 깐다.
 *
 *  필드는 position:fixed 라 스크롤해도 하늘이 따라오지 않는다.
 *  — 배송이 진행되는 동안 하늘은 그대로 있다는, 의도된 정지감.
 * ════════════════════════════════════════════════════════════════════════════════
 */
function StoreShell({theme, children, className}) {
    return (
        <div className={`st-root${className ? ` ${className}` : ''}`} data-theme={theme}>
            {/* 여명 필드 : 첫 햇빛 / 남은 밤 / 트이는 하늘 */}
            <div className="st-field" aria-hidden="true">
                <span/><span/><span/>
            </div>
            <div className="st-grain" aria-hidden="true"/>
            {children}
        </div>
    );
}

export default StoreShell;
